// src/pages/ForgotPassword.jsx
import React, { useState } from 'react';
import { motion } from 'framer-motion';
import api from '../api';
import './ForgotPassword.css';
import illustration from '../assets/login-illustration.jpeg';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async e => {
    e.preventDefault();
    setMessage('');
    setError('');
    try {
      await api.post('/forgot-password', { email });
      setMessage('📩 Te enviamos un enlace de recuperación a tu correo.');
    } catch (err) {
      console.error(err);
      setError(err.response?.data?.message || 'Error al enviar el enlace.');
    }
  };

  return (
    <div className="forgot-page">
      <motion.div
        className="forgot-left"
        initial={{ x: -200, opacity: 0 }}
        animate={{ x: 0, opacity: 1 }}
        transition={{ duration: 0.8 }}
      >
        <div className="forgot-logo">Escuela Online</div>
        <img src={illustration} alt="Recuperar contraseña" className="forgot-illu" />
      </motion.div>

      <motion.div
        className="forgot-right"
        initial={{ x: 200, opacity: 0 }}
        animate={{ x: 0, opacity: 1 }}
        transition={{ duration: 0.8 }}
      >
        <h2 className="forgot-title">¿Olvidaste tu contraseña?</h2>

        {error && <div className="forgot-error">{error}</div>}
        {message && <div className="forgot-success">{message}</div>}

        <form onSubmit={handleSubmit} className="forgot-form">
          <div className="forgot-field">
            <input
              type="email"
              placeholder="Correo electrónico"
              value={email}
              onChange={e => setEmail(e.target.value)}
              required
            />
          </div>
          <button type="submit" className="btn forgot-btn">
            Enviar enlace
          </button>
        </form>
      </motion.div>
    </div>
  );
}
